import classNames from 'classnames'
import { WarningCircle } from 'iconoir-react'
import { ReactElement, useState } from 'react'
import { useField } from 'remix-validated-form'
import { RichTextEditor } from '../editor/RichTextEditor'
import FormInputWrapper, { FormInputWrapperProps } from './FormInputWrapper'

export type FormMarkDownInputProps = {
  richTextEditorNamespace?: string
  editable?: boolean
  labelClassName?: string
  errorClassName?: string
  newLineError?: boolean
  description?: string
  preview?: boolean
} & FormInputWrapperProps<HTMLTextAreaElement>

export function FormMarkDownEditor({
  name,
  placeholder,
  editable,
  cols,
  label,
  description,
  errorClassName,
  showErrorIcon,
  richTextEditorNamespace,
  wrapperClassName,
  labelClassName,
  preview,
  ...props
}: FormMarkDownInputProps): ReactElement {
  const { error, defaultValue } = useField(name)
  const [value, setValue] = useState<string | undefined>(description ?? defaultValue)
  return (
    <FormInputWrapper
      {...{
        name,
        label,
        showErrorIcon,
        cols,
        wrapperClassName,
        className: labelClassName ?? `text-ui-sm`,
        errorClassName,
        defaultValue: props.defaultValue,
      }}
    >
      <RichTextEditor
        key={richTextEditorNamespace}
        namespace={richTextEditorNamespace ?? name}
        text={value}
        placeholder={placeholder}
        onChange={(text) => setValue(text)}
        editable={editable}
        preview={preview}
      />

      {value && <input name={name} type="hidden" defaultValue={value} />}
      {error && (
        <div
          className={classNames(
            errorClassName,
            `mt-[9px] flex items-center justify-end gap-x-2 text-body-sm text-red-600`,
          )}
        >
          {showErrorIcon && <WarningCircle className="h-full w-6 text-red-600" />}
          {error}
        </div>
      )}
    </FormInputWrapper>
  )
}
